import { __decorate, __param } from 'tslib';
import { Optional, Self, Inject, ChangeDetectorRef, ViewChild, Input, HostBinding, Component, ChangeDetectionStrategy, forwardRef, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';
import { AbstractTuiNullableControl, isNativeFocused, tuiDefaultProp, TUI_FOCUSABLE_ITEM_ACCESSOR, TuiCheckedModule, TuiFocusableModule, TuiFocusedModule, TuiHoveredModule, TuiPressedModule, TuiFocusVisibleModule } from '@taiga-ui/cdk';
import { TUI_CHECKBOX_OPTIONS, TuiPrimitiveCheckboxModule } from '@taiga-ui/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/core';
import * as ɵngcc2 from '@taiga-ui/cdk';
import * as ɵngcc3 from '@angular/forms';

const _c0 = ["focusableElement"];
var TuiCheckboxComponent_1;
let TuiCheckboxComponent = TuiCheckboxComponent_1 = class TuiCheckboxComponent extends AbstractTuiNullableControl {
    constructor(control, options, changeDetectorRef) {
        super(control, changeDetectorRef);
        this.options = options;
        this.size = this.options.size;
    }
    get nativeFocusableElement() {
        return !this.focusableElement || this.computedDisabled
            ? null
            : this.focusableElement.nativeElement;
    }
    get focused() {
        return isNativeFocused(this.nativeFocusableElement);
    }
    get computedFocusable() {
        return this.interactive && this.focusable;
    }
    onChecked(checked) {
        this.updateValue(checked);
    }
    onFocused(focused) {
        this.updateFocused(focused);
    }
    onHovered(hovered) {
        this.updateHovered(hovered);
    }
    onPressed(pressed) {
        this.updatePressed(pressed);
    }
    onFocusVisible(focusVisible) {
        this.updateFocusVisible(focusVisible);
    }
};
TuiCheckboxComponent.ɵfac = function TuiCheckboxComponent_Factory(t) { return new (t || TuiCheckboxComponent)(ɵngcc0.ɵɵdirectiveInject(NgControl, 10), ɵngcc0.ɵɵdirectiveInject(TUI_CHECKBOX_OPTIONS), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef)); };
TuiCheckboxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiCheckboxComponent, selectors: [["tui-checkbox"]], viewQuery: function TuiCheckboxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.focusableElement = _t.first);
    } }, hostVars: 1, hostBindings: function TuiCheckboxComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-size", ctx.size);
    } }, inputs: { size: "size" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                useExisting: forwardRef(() => TuiCheckboxComponent_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 11, consts: [[3, "size", "disabled", "focused", "hovered", "pressed", "invalid", "value"], ["type", "checkbox", "automation-id", "tui-checkbox__native", 1, "native", 3, "disabled", "id", "tuiChecked", "tuiFocusable", "tuiFocusedChange", "tuiHoveredChange", "tuiPressedChange", "tuiCheckedChange", "tuiFocusVisibleChange"], ["focusableElement", ""]], template: function TuiCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "tui-primitive-checkbox", 0);
        ɵngcc0.ɵɵelementStart(1, "input", 1, 2);
        ɵngcc0.ɵɵlistener("tuiFocusedChange", function TuiCheckboxComponent_Template_input_tuiFocusedChange_1_listener($event) { return ctx.onFocused($event); })("tuiHoveredChange", function TuiCheckboxComponent_Template_input_tuiHoveredChange_1_listener($event) { return ctx.onHovered($event); })("tuiPressedChange", function TuiCheckboxComponent_Template_input_tuiPressedChange_1_listener($event) { return ctx.onPressed($event); })("tuiCheckedChange", function TuiCheckboxComponent_Template_input_tuiCheckedChange_1_listener($event) { return ctx.onChecked($event); })("tuiFocusVisibleChange", function TuiCheckboxComponent_Template_input_tuiFocusVisibleChange_1_listener($event) { return ctx.onFocusVisible($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("size", ctx.size)("disabled", ctx.disabled)("focused", ctx.computedFocusVisible)("hovered", ctx.computedHovered)("pressed", ctx.computedPressed)("invalid", ctx.computedInvalid)("value", ctx.value);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("id", ctx.id)("tuiChecked", ctx.value)("tuiFocusable", ctx.computedFocusable);
    } }, directives: [ɵngcc1.TuiPrimitiveCheckboxComponent, ɵngcc2.TuiCheckedDirective, ɵngcc2.TuiFocusableDirective, ɵngcc2.TuiFocusedDirective, ɵngcc2.TuiHoveredDirective, ɵngcc2.TuiPressedDirective, ɵngcc2.TuiFocusVisibleDirective], styles: ["[_nghost-%COMP%]{font:var(--tui-font-text-s);color:var(--tui-text-01);position:relative;display:block;flex-shrink:0}[data-size='m'][_nghost-%COMP%]{width:1rem;height:1rem}[data-size='l'][_nghost-%COMP%]{width:1.5rem;height:1.5rem}._disabled[_nghost-%COMP%], ._readonly[_nghost-%COMP%]{pointer-events:none}.native[_ngcontent-%COMP%]{padding:0;border:0;border-radius:inherit;background:0 0;font-size:inherit;line-height:inherit;font-weight:inherit;color:inherit;caret-color:currentColor;outline:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;word-break:keep-all;-webkit-text-fill-color:currentColor;position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer}.native[_ngcontent-%COMP%]:-webkit-autofill, .native[_ngcontent-%COMP%]:-webkit-autofill:focus, .native[_ngcontent-%COMP%]:-webkit-autofill:hover{border-radius:inherit;color:inherit!important;background-color:transparent!important;-webkit-text-fill-color:var(--tui-text-01)!important;border-color:var(--tui-autofill);-webkit-box-shadow:0 0 0 1000px var(--tui-autofill) inset!important}"], changeDetection: 0 });
TuiCheckboxComponent.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NgControl,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_CHECKBOX_OPTIONS,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] }
];
__decorate([
    ViewChild('focusableElement')
], TuiCheckboxComponent.prototype, "focusableElement", void 0);
__decorate([
    Input(),
    HostBinding('attr.data-size'),
    tuiDefaultProp()
], TuiCheckboxComponent.prototype, "size", void 0);
TuiCheckboxComponent = TuiCheckboxComponent_1 = __decorate([ __param(0, Optional()),
    __param(0, Self()),
    __param(0, Inject(NgControl)),
    __param(1, Inject(TUI_CHECKBOX_OPTIONS)),
    __param(2, Inject(ChangeDetectorRef))
], TuiCheckboxComponent);

let TuiCheckboxModule = class TuiCheckboxModule {
};
TuiCheckboxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiCheckboxModule });
TuiCheckboxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiCheckboxModule_Factory(t) { return new (t || TuiCheckboxModule)(); }, imports: [[
            CommonModule,
            TuiCheckedModule,
            TuiFocusableModule,
            TuiFocusedModule,
            TuiHoveredModule,
            TuiPressedModule,
            TuiFocusVisibleModule,
            TuiPrimitiveCheckboxModule,
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiCheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'tui-checkbox',
                template: "<tui-primitive-checkbox\n    [size]=\"size\"\n    [disabled]=\"disabled\"\n    [focused]=\"computedFocusVisible\"\n    [hovered]=\"computedHovered\"\n    [pressed]=\"computedPressed\"\n    [invalid]=\"computedInvalid\"\n    [value]=\"value\"\n>\n    <input\n        #focusableElement\n        type=\"checkbox\"\n        automation-id=\"tui-checkbox__native\"\n        class=\"native\"\n        [disabled]=\"disabled\"\n        [id]=\"id\"\n        [tuiChecked]=\"value\"\n        [tuiFocusable]=\"computedFocusable\"\n        (tuiFocusedChange)=\"onFocused($event)\"\n        (tuiHoveredChange)=\"onHovered($event)\"\n        (tuiPressedChange)=\"onPressed($event)\"\n        (tuiCheckedChange)=\"onChecked($event)\"\n        (tuiFocusVisibleChange)=\"onFocusVisible($event)\"\n    />\n</tui-primitive-checkbox>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                        useExisting: forwardRef(() => TuiCheckboxComponent_1)
                    },
                ],
                styles: [":host{font:var(--tui-font-text-s);color:var(--tui-text-01);position:relative;display:block;flex-shrink:0}:host[data-size='m']{width:1rem;height:1rem}:host[data-size='l']{width:1.5rem;height:1.5rem}:host._disabled,:host._readonly{pointer-events:none}.native{padding:0;border:0;border-radius:inherit;background:0 0;font-size:inherit;line-height:inherit;font-weight:inherit;color:inherit;caret-color:currentColor;outline:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;word-break:keep-all;-webkit-text-fill-color:currentColor;position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer}.native:-webkit-autofill,.native:-webkit-autofill:focus,.native:-webkit-autofill:hover{border-radius:inherit;color:inherit!important;background-color:transparent!important;-webkit-text-fill-color:var(--tui-text-01)!important;border-color:var(--tui-autofill);-webkit-box-shadow:0 0 0 1000px var(--tui-autofill) inset!important}"]
            }]
    }], function () { return [{ type: ɵngcc3.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }, {
                type: Inject,
                args: [NgControl]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_CHECKBOX_OPTIONS]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }]; }, { size: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-size']
        }], focusableElement: [{
            type: ViewChild,
            args: ['focusableElement']
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiCheckboxModule, { declarations: function () { return [TuiCheckboxComponent]; }, imports: function () { return [CommonModule,
        TuiCheckedModule,
        TuiFocusableModule,
        TuiFocusedModule,
        TuiHoveredModule,
        TuiPressedModule,
        TuiFocusVisibleModule,
        TuiPrimitiveCheckboxModule]; }, exports: function () { return [TuiCheckboxComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiCheckboxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TuiCheckedModule,
                    TuiFocusableModule,
                    TuiFocusedModule,
                    TuiHoveredModule,
                    TuiPressedModule,
                    TuiFocusVisibleModule,
                    TuiPrimitiveCheckboxModule,
                ],
                declarations: [TuiCheckboxComponent],
                exports: [TuiCheckboxComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiCheckboxComponent, TuiCheckboxModule };

//# sourceMappingURL=taiga-ui-kit-components-checkbox.js.map